import { render, staticRenderFns } from "./areaModel1920.vue?vue&type=template&id=70ee2b6a&scoped=true&"
import script from "./areaModel1920.vue?vue&type=script&lang=js&"
export * from "./areaModel1920.vue?vue&type=script&lang=js&"
import style0 from "./areaModel1920.vue?vue&type=style&index=0&id=70ee2b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee2b6a",
  null
  
)

export default component.exports